module.exports = __webpack_public_path__ + "static/media/card.427e27df.png";